import React, { FC, ReactNode } from "react";
import { Link } from "@app/components/common/link/Link";
import { ILink } from "@app/models/storyblok/basic";
import { StoryblokLinkType } from "../enums";
import { StoryblokInternalLink } from "../storyblok-internal-link/StoryblokInternalLink";

type Props = {
  data: ILink;
  children: ReactNode;
};

export const StoryblokUniversalLink: FC<Props> = ({ data, children }) => (
  <>
    {data.linktype === StoryblokLinkType.STORY ? (
      <StoryblokInternalLink id={data.id}>{children}</StoryblokInternalLink>
    ) : (
      <Link to={data.url ?? ""}>{children}</Link>
    )}
  </>
);
